// extracted by mini-css-extract-plugin
export default {"prev":"Hgaqa","next":"O3HeQ"};